import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
//import { ConfirmationService, MessageService } from 'primeng/api';
// import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { DatePipe } from '@angular/common';
import { providePrimeNG } from 'primeng/config';
import { RTSTheme } from './Rtstheme';
import { ConfirmationService, MessageService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideAnimationsAsync(),
    MessageService,
    ConfirmationService,
    //importProvidersFrom(ConfirmDialogModule),
    provideHttpClient(withInterceptors([authInterceptor])),
    DatePipe,
    providePrimeNG({
      theme: {
        preset: RTSTheme,
        options: {
          prefix: 'rts',
          cssLayer: false,
          darkModeSelector: false || 'none'
        }
      }
    })
  ]
};
